/**
 * 文案翻译状态芯片。无独立 src 字段时：英语有文案=源，其它语言有文案=已维护，空=未译。
 * 不编造「机器翻译 / 人工修改」。
 */

export type OpsSrc = 'source' | 'filled' | '';

export function deriveOpsSrc(lang: string, text: string): OpsSrc {
  if (!text.trim()) return '';
  return lang === 'en' ? 'source' : 'filled';
}

const META: Record<OpsSrc, { label: string; cls: string }> = {
  source: { label: '英语源', cls: 'chip-info' },
  filled: { label: '已维护', cls: 'chip-pos' },
  '': { label: '未译', cls: 'chip-warn' },
};

export function OpsSrcChip({ src }: { src: OpsSrc }) {
  const m = META[src];
  return (
    <span className={`chip ${m.cls}`} style={{ fontSize: 10 }}>
      {m.label}
    </span>
  );
}
